import React from 'react'
import axios from "axios";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import NavFormProfile from './NavFormProfile';
import AdminNavFormProfile from './AdminNavFormProfile';


import Path from "./config";

class FamilyInfo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            sbg_unmarried_brother: "",
            sbg_married_brother: "",
            sbg_unmarried_sister: "",
            sbg_married_sister: "",
            sbg_mother_full_name: "",
            sbg_father_full_name: "",
            sbg_other_mobile_no1: "",
            sbg_other_mobile_no2: "",
            sbg_parents_address: "",
            sbg_parent_job_buisness: "",
            prifixList: [],
            typee: "family",
            islogin: false,
            isValid: true,
            mobilelength: "0",
            phonelength: "0",
            NavMenu: false

        }

    }



    componentDidMount() {

        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("userId")
        })

        if (localStorage.getItem("admin") === "Admin") {
            this.setState({
                NavMenu: true
            })
        }


        axios.get(Path + 'Suchi_bride_groom_familyinfo.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                // handle success
                // console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                //   data=response.data;
                response = response.data;
                // var array = response.sbg_mother_full_name.split(".");
                // var array1 = response.sbg_father_full_name.split(".");

                this.setState({


                    sbg_unmarried_brother: response.sbg_unmarried_brother,
                    mobilelength: response.sbg_other_mobile_no1.length,
                    sbg_married_brother: response.sbg_married_brother,
                    sbg_unmarried_sister: response.sbg_unmarried_sister,
                    sbg_married_sister: response.sbg_married_sister,
                    sbg_mother_full_name: response.sbg_mother_full_name,
                    sbg_mother_prifix: response.sbg_mother_prifix,
                    sbg_father_prifix: response.sbg_father_prifix,
                    sbg_father_full_name: response.sbg_father_full_name,
                    sbg_other_mobile_no1: response.sbg_other_mobile_no1,
                    sbg_other_mobile_no2: response.sbg_other_mobile_no2,
                    sbg_parents_address: response.sbg_parents_address,
                    sbg_parent_job_buisness: response.sbg_parent_job_buisness,

                })
            }.bind(this))

        // ********************** select  prifix ************************
        axios.get(Path + 'Suchi_bride_groom_name_prifix.php')
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);
                this.setState({ prifixList: response.data.prifix_list })
            }.bind(this))
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }




    unbrotherHandler = (e) => {
        const re = /^[0-9\b]+$/;
        document.getElementById("sbg_unmarried_brother").style.borderColor = "";
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_unmarried_brother: e.target.value })
        }
    }

    mbrotherHandler = (e) => {
        const re = /^[0-9\b]+$/;
        document.getElementById("sbg_married_brother").style.borderColor = "";
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_married_brother: e.target.value })
        }
    }

    unsisiterHandler = (e) => {
        const re = /^[0-9\b]+$/;
        document.getElementById("sbg_unmarried_sister").style.borderColor = "";
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_unmarried_sister: e.target.value })
        }
    }

    msisterHandler = (e) => {
        const re = /^[0-9\b]+$/;
        document.getElementById("sbg_married_sister").style.borderColor = "";
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_married_sister: e.target.value })
        }
    }

    prifixHandler = (e) => {
        document.getElementById("sbg_mother_prifix").style.borderColor = "";
        this.setState({ sbg_mother_prifix: e.target.value });
    }

    fprifixHandler = (e) => {
        document.getElementById("sbg_father_prifix").style.borderColor = "";
        this.setState({ sbg_father_prifix: e.target.value });
    }

    motherHandler = (e) => {

        document.getElementById("mname").style.borderColor = "";

        let data = e.target.value;
        if (data.length > 60) {

        } else {
            this.setState
                ({ sbg_mother_full_name: e.target.value })
        }

    }

    fatherHandler = (e) => {
        document.getElementById("fname").style.borderColor = "";

        let data = e.target.value;
        if (data.length > 60) {

        } else {
            this.setState
                ({ sbg_father_full_name: e.target.value })
        }

    }

    mobileHandler = (e) => {
        document.getElementById("mobile").style.borderColor = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_other_mobile_no1: e.target.value }, () => {
                this.setState({
                    mobilelength: this.state.sbg_other_mobile_no1.length
                })


            })

        }
    }
    phoneHandler = (e) => {
        document.getElementById("phone").style.borderColor = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_other_mobile_no2: e.target.value }, () => {
                this.setState({ phonelength: this.state.sbg_other_mobile_no2.length })

            })
        }
    }

    vaddressHandler = (e) => {


        let data = e.target.value;
        if (data.length > 60) {

        } else {
            this.setState
                ({ sbg_parents_address: e.target.value })
        }

    }

    occuHandler = (e) => {


        let data = e.target.value;
        if (data.length > 40) {

        } else {
            this.setState
                ({ sbg_parent_job_buisness: e.target.value })
        }

    }




    submitClick = (e) => {
        let isValid = true;
        // console.log("legth of mobile",this.state.mobilelength)
        if (this.state.sbg_mother_full_name === "") {
            document.getElementById("mname").style.borderColor = "red";
            isValid = false;
        } else {
            const a = this.state.sbg_mother_full_name.split(' ');
            if (a.length < 4) {
                document.getElementById("mname").style.borderColor = "red";
                isValid = false;
            }

        }
        if (this.state.sbg_father_full_name === "") {
            document.getElementById("fname").style.borderColor = "red";
            isValid = false;
        } else {
            const a = this.state.sbg_father_full_name.split(' ');
            if (a.length < 4) {
                document.getElementById("fname").style.borderColor = "red";
                isValid = false;
            }

        }

        if (this.state.sbg_unmarried_brother === "") {
            document.getElementById("sbg_unmarried_brother").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_married_brother === "") {
            document.getElementById("sbg_married_brother").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_unmarried_sister === "") {
            document.getElementById("sbg_unmarried_sister").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_married_sister === "") {
            document.getElementById("sbg_married_sister").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_other_mobile_no1 === "") {
            document.getElementById("mobile").style.borderColor = "red";
            isValid = false;
        }
        else if (this.state.mobilelength < 10) {
            isValid = false;
            document.getElementById("mobile").style.borderColor = "red";
        }
        // if(this.state.phonelength<10)
        // {
        //     isValid = false ;
        //     document.getElementById("phone").style.borderColor = "red";
        // }

        if (this.state.sbg_father_prifix === "0" || this.state.sbg_father_prifix === "f") {
            document.getElementById("sbg_father_prifix").style.borderColor = "red";
            isValid = false;
        }

        if (this.state.sbg_mother_prifix === "0" || this.state.sbg_mother_prifix === "f") {
            document.getElementById("sbg_mother_prifix").style.borderColor = "red";
            isValid = false;
        }
        if (this.state.sbg_parents_address === "") {
            document.getElementById("sbg_parents_address").style.borderColor = "red";
            isValid = false;
        }

        if (isValid === true) {

            let typee = "family";

            let tempStr = "sbg_unmarried_brother=" + this.state.sbg_unmarried_brother +
                "&sbg_married_brother=" + this.state.sbg_married_brother +
                "&sbg_unmarried_sister=" + this.state.sbg_unmarried_sister +
                "&sbg_married_sister=" + this.state.sbg_married_sister +

                "&sbg_father_prifix=" + this.state.sbg_father_prifix +
                "&sbg_mother_prifix=" + this.state.sbg_mother_prifix +

                "&sbg_mother_full_name=" + this.state.sbg_mother_full_name +
                "&sbg_father_full_name=" + this.state.sbg_father_full_name +
                "&sbg_other_mobile_no1=" + this.state.sbg_other_mobile_no1 +
                "&sbg_other_mobile_no2=" + this.state.sbg_other_mobile_no2 +
                "&sbg_parents_address=" + this.state.sbg_parents_address +
                "&sbg_parent_job_buisness=" + this.state.sbg_parent_job_buisness +
                "&sbg_id=" + this.state.userId +
                "&type=" + typee

            axios.post(Path + `Suchi_Bride_Groom_update.php?` + tempStr)
                .then(function (response) {
                    // console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data);


                    if (response.data.status === "updated") {
                        // localStorage.setItem("userId",response.data.sbg_id)
                        if (this.state.admin === "Admin") {
                            this.props.history.push(`/AdminProfile/ContactInfo`);
                        }
                        else {
                            this.props.history.push(`/FormProfile/ContactInfo`);
                        }
                    }
                    //alert("Updated Successfully");


                }.bind(this))
        }
        else {
            //alert ("Please fill up all compalsary fields");
            document.getElementById("error").innerHTML = "कृपया अनिवार्य माहिती पूर्ण भरावी.";
        }
        e.preventDefault();
    }

    render() {

        let prifix_Listm = this.state.prifixList.map((pr, index) => {
            const { pr_id, pr_name } = pr //destructuring
            return (

                <option key={pr_id} value={pr_id}> {pr_name} </option>

            )
        })

        let prifix_Listf = this.state.prifixList.map((pr, index) => {
            const { pr_id, pr_name } = pr //destructuring
            return (

                <option key={pr_id} value={pr_id}> {pr_name} </option>

            )
        })
        return (
            <>
                {this.state.NavMenu ? <AdminNavFormProfile /> : <NavFormProfile />}
                <div className="m-5 pt-3" >
                    {/* <span className="pt-3 mx-auto" >वैयक्तिक माहिती </span> */}
                    <p className="text-primary">कृपाय आपल्या भाऊ बहीण  यांचा तपशील फक्त अंकात लिहिणे आवश्यक आहे.</p>
                    <form className="row g-3">
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label">अविवाहित भाऊ   </label><br />
                            <input type="text" className="form-control" maxLength="1" id="sbg_unmarried_brother" name="sbg_unmarried_brother" value={this.state.sbg_unmarried_brother} onChange={this.unbrotherHandler} />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label">विवाहित भाऊ  </label><br />
                            <input type="text" className="form-control" maxLength="1" id="sbg_married_brother" name="sbg_married_brother" value={this.state.sbg_married_brother} onChange={this.mbrotherHandler} />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label"> अविवाहित बहीण  </label><br />
                            <input type="text" className="form-control" maxLength="1" id="sbg_unmarried_sister" name="sbg_unmarried_sister" value={this.state.sbg_unmarried_sister} onChange={this.unsisiterHandler} />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="inputEmail4" className="form-label">विवाहित बहीण  </label><br />
                            <input type="text" className="form-control" maxLength="1" id="sbg_married_sister" name="sbg_married_sister" value={this.state.sbg_married_sister} onChange={this.msisterHandler} />
                        </div>

                        <div className="col-md-2">
                            <label htmlFor="inputEmail4" className="form-label">*आईचे पूर्ण नाव    </label>
                            <select id="sbg_mother_prifix" value={this.state.sbg_mother_prifix} onChange={this.prifixHandler} className="date_combo form-select" style={{ width: "90%" }}>
                                <option value="f">Select</option>
                                {prifix_Listm}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label"> .  </label>
                            <br></br>
                            <ReactTransliterate placeholder='आईचे पूर्ण नाव ' id="mname" name="sbg_mother_full_name" value={this.state.sbg_mother_full_name} onChange={this.motherHandler} className="txt_box" style={{ width: "100%" }} />
                        </div>

                        <div className="col-md-2">

                            <label htmlFor="inputEmail4" className="form-label">*वडिलांचे पूर्ण नाव    </label><br />
                            <select id="sbg_father_prifix" value={this.state.sbg_father_prifix} onChange={this.fprifixHandler} className="date_combo form-select" style={{ width: "90%" }}>
                                <option value="f">Select</option>
                                {prifix_Listf}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label"> .  </label>
                            <br></br>
                            <ReactTransliterate maxLength="60" id="fname" placeholder='वडिलांचे पूर्ण नाव ' name="sbg_father_full_name" value={this.state.sbg_father_full_name} onChange={this.fatherHandler} className="txt_box" style={{ width: "100%" }} />

                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label">*मोबाइल नंबर 1    </label>
                            <input type="text" maxLength="13" minlength="10" name="sbg_other_mobile_no1" value={this.state.sbg_other_mobile_no1} onChange={this.mobileHandler} className="form-control" id="mobile" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label">मोबाइल नंबर 2   </label>
                            <input type="text" maxLength="13" minlength="10" name="sbg_other_mobile_no2" value={this.state.sbg_other_mobile_no2} onChange={this.phoneHandler} className="form-control" id="phone" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label">व्यवसाय   </label>
                            <ReactTransliterate name="sbg_parent_job_buisness" value={this.state.sbg_parent_job_buisness} onChange={this.occuHandler} className="form-control" />
                        </div>
                        <div className="col-md-12">
                            <label htmlFor="inputEmail4" className="form-label">*आई वडिलांचा पत्ता   </label>
                            <ReactTransliterate renderComponent={(props) => <textarea {...props} />} id="sbg_parents_address" name="sbg_parents_address" value={this.state.sbg_parents_address} onChange={this.vaddressHandler} className="form-control" placeholder="थोडक्यात पत्ता टाकावा " />
                        </div>









                        <div className="col-12">
                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save & Next ▶️</button>
                            <br></br>
                            <span className='text-danger font-weight-bold' id="error"></span> &nbsp;&nbsp;&nbsp;
                        </div>
                    </form>
                </div>
            </>
        )
    }
}

export default FamilyInfo
